const create = {
  eval_questionnaire_add_directly: 'eval_questionnaire_add_directly',
  eval_questionnaire_add_bankcreation: 'eval_questionnaire_add_bankcreation',
  eval_questionnaire_add_combination: 'eval_questionnaire_add_combination'
};

const manage = {
  evalProjectListGet: 'eval_tools_list_get'
};

export default {
  ...create,
  ...manage,
  data: {
    eval_tools_list_get_extent: 'eval_tools_list_get_extent' // 问卷获取范围
  }
};
